import WebapiCommon from '@common/util/webapi.common';
import { editorRunat, editorUrl } from '@constants/defaultValues';
import * as localStorage from '../../../localStorage.util';
import { defaultDataEmpty } from './editor.data';
import IntlMessage from '../../../helpers/intlMessage';
import React from 'react';

export const finalizar = (actions) => {
  actions.autoSaveEditor(false);
  actions.etapaAtual(undefined);

  const frame = document.getElementById('iframe-editor');

  if (frame !== null) {
    actions.showEditor(false);
    frame.style.display = 'none';
    if (editorRunat === 'client') {
    }
  }

  actions.editorInicializado(false);
};

export function mudarNomeAbaPrincipal(newName) {
  let frame = document.getElementById('iframe-editor');
  if (frame !== null) {
    frame.contentWindow.postMessage(
      {
        method: 'mudarNomeAbaPrincipal',
        title: newName,
        urlHost: editorUrl,
      },
      editorUrl,
    );
  }
}

export function addCustomButton(
  id,
  label,
  iconId,
  startsGroup,
  adicionarAoPrincipal,
  abaId,
  abaTexto,
  indice,
  mostrarTexto,
  modoToggle,
  selectedInicial,
) {
  const frame = document.getElementById('iframe-editor');
  if (frame !== null) {
    frame.contentWindow.postMessage(
      {
        method: 'adicionarBotao',
        commandId: id,
        commandLabel: label,
        commandIcon: iconId,
        beginGroup: startsGroup,
        addToHome: adicionarAoPrincipal,
        customTabId: abaId,
        customTabLabel: abaTexto,
        buttonIndex: indice,
        showText: mostrarTexto,
        toggleMode: modoToggle,
        initialToggleStatus: selectedInicial,
        urlHost: editorUrl,
      },
      editorUrl,
    );
  }
}

export const laudar = (actions, concluir) => {
  try {
    actions.showFadeCarregando(true);

    if (window.$editor_carregado) {
      const frame = document.getElementById('iframe-editor');

      if (frame !== null) {

        frame.contentWindow.postMessage(
          {
            method: 'recuperarWrappersRTF',
            urlHost: editorUrl,
          },
          editorUrl
        );

        setTimeout(() => {
          frame.contentWindow.postMessage(
            {
              method: 'recuperarTextoRtfAndPlainText',
              urlHost: editorUrl,
              args: {
                action: concluir? 'laudarConcluir' : 'laudar'
              }
            },
            editorUrl
          );
        }, 500);

        actions.editorInicializado(false);
      }
    } else {
      actions.showAlerta(
        'erro',
        'Instância do editor não carregada.',
        2000,
        '550px'
      );
      actions.showFadeCarregando(false);
    }
  } catch (error) {
    actions.showFadeCarregando(false);
  }
};

export const converterRtfToPlainText = (text, actions) => {
  try {
    const frame = document.getElementById('iframe-editor');

    if (frame !== null) {
      frame.contentWindow.postMessage(
        {
          method: 'convertRtfToPlainText',
          urlHost: editorUrl,
          args: {
            text: text,
          },
        },
        editorUrl
      );
    }
  } catch (error) {
    actions.showAlerta('erro', error.message, 2000, '550px');
  }
};

export const Inicializar = (props, etapa, readOnly = false) => {
  const { commonActions, editorActions } = props;
  const laudo = props.detalhes.laudo;
  const etapaDaVez = etapa;

  editorActions.editorReadOnly(readOnly);
  commonActions.showFadeCarregando(true);
  commonActions.showEditor(true);
  commonActions.editorInicializado(true);
  commonActions.autoSaveEditor(true);
  commonActions.etapaAtual(etapa);
  commonActions.eventokeyUpFoiDisparadoNoEditor(false);
  commonActions.textoInicial(true);
  localStorage.removeTextoLaudoNoLocalStorage();

  Promise.all([WebapiCommon.getTextoLaudo(laudo, etapa)]).then(
    (responseArray) => {
      let tentativas = 0;
      let interval = setInterval(() => {
        if (window.$editor_carregado) {
          const frame = document.getElementById('iframe-editor');

          if (frame !== null && frame.contentWindow.length !== 0) {
            try {
              frame.style.display = 'block';
              const response = responseArray[0];
              const chave = "texto_" + props.detalhes.laudo.toString() + "_" + etapaDaVez.toLowerCase();//props.etapaAtual.toLowerCase();
              let textRtf;
              let textoRtfLocalStorage = localStorage.getTextoLaudoAutoSave(chave);
              let textoExistente = response.data.rtf !== null ? response.data.rtf : '';

              if (response.data.etapaConcluida)
                textRtf = textoExistente
              else
                textRtf = textoRtfLocalStorage !== null ? textoRtfLocalStorage : textoExistente;

              localStorage.setTextoLaudoNoLocalStorage(textRtf);
              localStorage.setTextoLaudoPlainTextNoLocalStorage(response.data.plainText);

              const headerFooterRtf = response.data.headerfooter !== null ? response.data.headerfooter : '';
              const id = response.data.id !== null ? response.data.id : '';
              const medExecutante = response.data.medicoExecutante !== null ? response.data.medicoExecutante : '';
              const medRevisor = response.data.medicoRevisor !== null ? response.data.medicoRevisor : '';

              if (!textRtf) {
                editorActions.editorRtf(textRtf);
                editorActions.idRtf(id);
                commonActions.preencherIdRtf(id);
                medExecutante && editorActions.ChangeMedExecutante(medExecutante);
                medRevisor && editorActions.ChangeMedRevisor(medRevisor);
                commonActions.showFadeCarregando(false);

                frame.contentWindow.postMessage(
                  {
                    method: 'substituirTexto',
                    text: defaultDataEmpty,
                    type: 'rtf',
                    runat: editorRunat,
                    breakLine: false,
                    cleanBefore: true,
                  },
                  editorUrl
                );
              } else {
                frame.contentWindow.postMessage(
                  {
                    method: 'substituirTexto',
                    text: textRtf,
                    type: 'rtf',
                    runat: editorRunat,
                    breakLine: false,
                    cleanBefore: true,
                  },
                  editorUrl
                );
                editorActions.editorRtf(textRtf);
                editorActions.idRtf(id);
                commonActions.preencherIdRtf(id);
                medExecutante && editorActions.ChangeMedExecutante(medExecutante);
                medRevisor && editorActions.ChangeMedRevisor(medRevisor);
              }

              setTimeout(() => {
                commonActions.showFadeCarregando(false);
              }, 3000);

              clearInterval(interval);
              commonActions.editorInicializado(true);
            } catch (error) {
              console.log(error);
              clearInterval(interval);
              commonActions.showFadeCarregando(false);
            }
          }
        } else {
          tentativas++;
          console.log(`Editor tentou carregar ${tentativas} ${editorUrl} vezes.`);

          if (tentativas >= 30) {
            clearInterval(interval);
            commonActions.showFadeCarregando(false);
            commonActions.editorInicializado(false);

            let msg = <IntlMessage id = "message.errorEditor"/>;
            commonActions.showAlerta('alerta', msg, 3000, msg.length * 10 + 'px');
          }
        }
      }, 300);
    }
  );
};

export const Imprimir = (commonActions) => {
  RecuperarTextoPreview(commonActions);
};

export const RecuperarHeaderAndFooter = (commonActions) => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarWrappersRTF',
      urlHost: editorUrl,
      args: { action: 'getTextPreview' },
    },
    editorUrl
  );
};

export const RecuperarTextoPreview = (commonActions) => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarTextoRtfAndPlainText',
      urlHost: editorUrl,
      args: { action: 'getTextPreview' },
    },
    editorUrl
  );
};

export const recuperarTextoParaAutoSave = () => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarTextoRtfAndPlainText',
      urlHost: editorUrl,
      args: { action: 'obterTextoParaAutoSave' },
    },
    editorUrl
  );
};
export const recuperarTextoRtf = (commonActions) => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarTextoRtf',
      urlHost: editorUrl,
      args: { action: 'recuperarTextoRtf' },
    },
    editorUrl
  );
};

export const verificarPlainTextMudou = (commonActions) => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarTextoRtfAndPlainText',
      urlHost: editorUrl,
      args: {
        action: 'verificarPlainTextMudou',
      },
    },
    editorUrl,
  );
};

export const recuperarTextoRtfAndPlainText = (commonActions) => {
  const frame = document.getElementById('iframe-editor');

  frame.contentWindow.postMessage(
    {
      method: 'recuperarTextoRtfAndPlainText',
      urlHost: editorUrl,
      args: {
      },
    },
    editorUrl,
  );
};



// WEBPACK FOOTER //
// ./src/pages/laudo/editor/editor.util.js